import { useState } from "react";

export default function InputRange({
  value,
  setValue, // start value in percent
}) {
  const [isDragging, setIsDragging] = useState(false);

  // Slider itself goes 0 → 100, but we *display* 100 → 0 like your image

  return (
    <div className="w-full pt-0.5 flex flex-col items-center gap-0.5">
      {/* top row: 100  ---- slider ----  0 */}
      <div className="w-full flex items-center gap-1 sm:gap-2.5">
        <span className="text-xs sm:text-sm text-zi-text-light/50 dark:text-zi-text-dark/50">
          0
        </span>

        <input
          type="range"
          min="0"
          max="100"
          value={value}
          aria-label="درصد سرمایه"
          aria-valuetext={`${value.toFixed(2)} درصد`}
          onChange={(e) => setValue(Number(e.target.value))}
          onPointerDown={() => setIsDragging(true)}
          onPointerUp={() => setIsDragging(false)}
          onPointerCancel={() => setIsDragging(false)}
          onLostPointerCapture={() => setIsDragging(false)}
          onBlur={() => setIsDragging(false)}
          style={{
            backgroundColor: "transparent",
            backgroundImage: `
              radial-gradient(circle, ${
                value >= 100
                  ? "var(--slider-active)"
                  : "var(--slider-inactive)"
              } 0 1.5px, transparent 1.5px),
              radial-gradient(circle, ${
                value <= 0
                  ? "var(--slider-inactive)"
                  : "var(--slider-active)"
              } 0 1.5px, transparent 1.5px),
              linear-gradient(
                to left,
                var(--slider-active) 0%,
                var(--slider-active) ${value}%,
                var(--slider-inactive) ${value}%,
                var(--slider-inactive) 100%
              )
            `,
            backgroundPosition: "left center, right center, center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "3px 3px, 3px 3px, calc(100% - 3px) 3px",
            "--slider-thumb-size": isDragging ? "18px" : "14px",
            "--slider-thumb-offset": isDragging ? "-7.5px" : "-5.5px",
          }}
          className="
            w-full h-5 outline-none cursor-grab active:cursor-grabbing appearance-none rounded-full bg-transparent
            [--slider-active:#2878A3]
            [--slider-inactive:#94a3b866]
            [--slider-thumb:#2878A3]
            [--slider-gap:#fff]
            dark:[--slider-active:#a3a3a3]
            dark:[--slider-inactive:#404040]
            dark:[--slider-thumb:#d4d4d4]
            dark:[--slider-gap:#161616]
            [&::-webkit-slider-runnable-track]:h-[3px]
            [&::-webkit-slider-runnable-track]:rounded-full
            [&::-webkit-slider-runnable-track]:bg-transparent
            [&::-webkit-slider-runnable-track]:border-none
            [&::-webkit-slider-runnable-track]:appearance-none
            [&::-webkit-slider-thumb]:appearance-none
            [&::-webkit-slider-thumb]:size-[var(--slider-thumb-size)]
            [&::-webkit-slider-thumb]:rounded-full
            [&::-webkit-slider-thumb]:border-0
            [&::-webkit-slider-thumb]:bg-[var(--slider-thumb)]
            [&::-webkit-slider-thumb]:shadow-[0_0_0_2px_var(--slider-gap)]
            [&::-webkit-slider-thumb]:mt-[var(--slider-thumb-offset)]
            [&::-webkit-slider-thumb]:transition-[width,height,margin,box-shadow]
            [&::-webkit-slider-thumb]:duration-150
            [&::-moz-range-track]:h-[3px]
            [&::-moz-range-track]:rounded-full
            [&::-moz-range-track]:bg-transparent
            [&::-moz-range-track]:border-none
            [&::-moz-range-thumb]:size-[var(--slider-thumb-size)]
            [&::-moz-range-thumb]:rounded-full
            [&::-moz-range-thumb]:border-0
            [&::-moz-range-thumb]:bg-[var(--slider-thumb)]
            [&::-moz-range-thumb]:shadow-[0_0_0_2px_var(--slider-gap)]
            [&::-moz-range-thumb]:transition-[width,height,box-shadow]
            [&::-moz-range-thumb]:duration-150
          "
        />
        <span className="text-xs sm:text-sm text-zi-text-light/50 dark:text-zi-text-dark/50">
          100
        </span>
      </div>

      {/* bottom centered value */}
      <div className="text-sm font-medium text-zi-text-light dark:text-zi-text-dark">
        {value.toFixed(2)}%
      </div>
    </div>
  );
}
